import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import React, { useCallback, useEffect, useState } from "react";
import { FormikHelpers } from "formik";
import { ContentStyle, DRxTheme } from "../../../Theme";
import { useLocation, useNavigate } from "react-router";
import { DialogPopup } from "../../../components/DialogPopup";
import { PatientPharmacyInfoCard } from "../../../components/Content";
import { HelpGuideTooltip } from "../../../components/HelpGuideTooltip";
import {
  RxChangeAlertsApprovedWithChanges,
  RxChangeAlertsDetails,
  RxChangeAlertsSendToPharmacy,
} from "../../../Apis/AuthApiServices";
import { useDispatch } from "react-redux";
import PatientNotMatchPopUp from "../../../components/PatientNotMatchPopUp";
import DrugNotMatchPopUp from "../../../components/DrugNotMatchPopUp";
import YSSnackBar from "../../../uikit/YSSnackBar";
import { loadingTopRibbon } from "../../../Redux/Slice/TopRibbonSlice";
import { loadingPharmacyDropDown } from "../../../Redux/Slice/PharmacyDropDownSlice";
import { RxChangeAlertForm } from "../../../constants/RxChangeAlerts/rxChangeAlerts";
import MedPrescribedForm from "../../../components/RxChangeAlerts/MedPrescribeForm";
import MedPrescribeRequested from "../../../components/RxChangeAlerts/MedPrescribeRequested";
import MedicationRequestedList from "../../../components/RxChangeAlerts/MedicationRequestedList";
import PrescribedStatusPopup from "../../../components/RxChangeAlerts/PrescribedStatusPopup";

export default function PendingRxChangeAlertsRequest(props: any) {
  const [actionType, setActionType] = useState<string>("");
  const [rxChangeAlertsRequestData, setRxChangeAlertsRequestData] =
    useState<any>({});
  const [patientInformation, setPatientInformation] = useState<any>(null);
  const [medRequestSelectedData, setMedRequestSelectedData] = useState<any>({});
  const dispatch = useDispatch();
  const location: any = useLocation();
  const [matchingList, setMatchingList] = useState(false);
  const [loader, setLoader] = useState(true);
  const [stateData, setStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const [MedRequestPopup, setMedRequestPopup] = useState(false);
  const handleShowMedRequestPopupClick = useCallback(() => {
    setMedRequestPopup(true);
  }, []);
  const handleHideMedRequestPopupClick = useCallback(() => {
    setMedRequestPopup(false);
  }, []);
  const [DrugNotMatchPopup, setDrugNotMatchPopup] = useState(false);
  const handleShowDrugNotMatchPopupClick = () => {
    setDrugNotMatchPopup(true);
  };
  const handleHideDrugNotMatchPopupClick = () => {
    setDrugNotMatchPopup(false);
  };
  const [PatientNotMatchPopup, setPatientNotMatchPopup] = useState(false);
  const handleShowPatientNotMatchPopupClick = () => {
    setPatientNotMatchPopup(true);
  };
  const handleHidePatientNotMatchPopupClick = () => {
    setPatientNotMatchPopup(false);
  };

  const navigate = useNavigate();
  const [ApprovedPopup, setApprovedPopup] = useState(false);
  const handleShowApprovedPopupClick = () => {
    setApprovedPopup(true);
  };
  const handleHideApprovedPopupClick = () => {
    setApprovedPopup(false);
    navigate("/pendingrxchangealerts");
  };

  const history = useNavigate();

  const handleBackClick = () => {
    history("/pendingrxchangealerts");
  };

  const [sendToPharmacyData, setSendToPharmacyData] = useState([]);

  const getValuesOfDropDown = (options: any, substitutionCode: string) => {
    return (
      options.find((item: any) => item?.id === substitutionCode)?.name ??
      "Not Available"
    );
  };
  console.log("process.env.REACT_APP_ENV", process.env.REACT_APP_ENV);
  const getRxchangeAlertsDetails = async () => {
    try {
      const params = new URLSearchParams();
      params.append("doctorId", location?.state?.rowData?.doctorId);
      params.append("messageId", location?.state?.rowData?.messageId);
      params.append("rxChangeId", ""); //location?.state?.rowData?.id);
      const result = await RxChangeAlertsDetails(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        let substitutionName = getValuesOfDropDown(
          // result?.data?.response[0]?.substitutionCodeOptions,
          result?.data?.response[0]?.medicationPrescribed
            ?.substitutionCodeOptions,
          result?.data?.response[0]?.medicationPrescribed?.substitutionCode
        );
        setRxChangeAlertsRequestData({
          ...result?.data?.response[0],
          medicationPrescribed: {
            ...result?.data?.response[0]?.medicationPrescribed,
            reasonDenied: "0", // Doubt
            substitutionName,
          },
        });
        setPatientInformation(result?.data?.response[0]?.patientInformation);
        substitutionName = getValuesOfDropDown(
          // result?.data?.response[0]?.substitutionCodeOptions,
          result?.data?.response[0]?.medicationRequested[0]
            ?.substitutionCodeOptions,
          result?.data?.response[0]?.medicationRequested[0]?.substitutionCode
        );
        setMedRequestSelectedData({
          ...result?.data?.response[0]?.medicationRequested[0],
          reasonDenied: "0",
          substitutionName,
        });
        if (result?.data?.response[0]?.patientMismatchPopupFlag) {
          handleShowPatientNotMatchPopupClick();
        } else if (result?.data?.response[0]?.drugMismatchPopupFlag) {
          handleShowDrugNotMatchPopupClick();
        }
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
    }
  };
  useEffect(() => {
    getRxchangeAlertsDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (
    values: RxChangeAlertForm,
    actions: FormikHelpers<RxChangeAlertForm>
  ) => {
    switch (actionType) {
      case "Back":
        handleBackClick();
        break;
      case "Denied":
        if (
          matchingList ||
          !rxChangeAlertsRequestData?.patientMismatchPopupFlag
        ) {
          const isReset = await gotoSendToPharmacy(values, "DENIED");
          if (isReset) {
            actions.resetForm();
          }
        } else {
          setStateData((prevState: any) => {
            return {
              ...prevState,
              message: "Please Select patient mismatch from patient mismatch",
              variant: "error",
              open: true,
            };
          });
          handleShowPatientNotMatchPopupClick();
          setActionType("");
        }
        break;
      case "Approved With Changes":
        if (
          matchingList ||
          !rxChangeAlertsRequestData?.patientMismatchPopupFlag
        ) {
          getRxChangeAlertsApprovedWithChanges(values);
        } else {
          setStateData((prevState: any) => {
            return {
              ...prevState,
              message: "Please Select patient mismatch from patient mismatch",
              variant: "error",
              open: true,
            };
          });
          handleShowPatientNotMatchPopupClick();
          setActionType("");
        }
        break;
      case "Approved":
        if (
          matchingList ||
          !rxChangeAlertsRequestData?.patientMismatchPopupFlag
        ) {
          const isReset = await gotoSendToPharmacy(values, "APPROVED");
          if (isReset) {
            actions.resetForm();
          }
        } else {
          setStateData((prevState: any) => {
            return {
              ...prevState,
              message: "Please Select patient mismatch from patient mismatch",
              variant: "error",
              open: true,
            };
          });
          handleShowPatientNotMatchPopupClick();
          setActionType("");
        }
        break;
      default:
    }
  };

  const gotoSendToPharmacy = async (values: any, ACTION: any) => {
    try {
      const bodyData = {
        messageId: rxChangeAlertsRequestData?.messageId,
        matchingPatientFoundFlag: matchingList ? "1" : "0",
        matchingDrugFoundFlag: medRequestSelectedData.medicationRequestID
          ? "1"
          : "0",
        matchingPatientId: patientInformation?.patientId,
        matchingDrugId: medRequestSelectedData?.drugID ?? "",
        note: values?.refillNotes,
        refillAction: ACTION,
        denialReason: values?.reasonDenied === "0" ? "" : values?.reasonDenied,
        refillCount: values?.refills,
        priorAuthorization: values?.paInformation,
        prescriberAgentId: localStorage.getItem("doctorId"),
        userDetails: {
          doctorId: rxChangeAlertsRequestData?.doctorId,
          onBehalfDoctorId: "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
        rxChangeMedRequestId: medRequestSelectedData?.medicationRequestID,
      };
      const result = await RxChangeAlertsSendToPharmacy(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        handleShowApprovedPopupClick();
        setSendToPharmacyData(result?.data?.response);
        dispatch(loadingTopRibbon());
        return true;
      } else {
        setSendToPharmacyData([]);
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      setSendToPharmacyData([]);
      setStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Something went wrong!",
          variant: "error",
          open: true,
        };
      });
    } finally {
      setActionType("");
      return false;
    }
  };
  const getRxChangeAlertsApprovedWithChanges = async (values: any) => {
    try {
      const bodyData = {
        messageId: location?.state?.rowData?.messageId,
        refillAction: "Approved with changes",
        patientId: location?.state?.rowData?.patientId,
        prescriberAgentId: localStorage.getItem("doctorId"),
        userDetails: {
          userId: localStorage.getItem("LoginUserID"),
          doctorId: rxChangeAlertsRequestData?.doctorId,
          onBehalfDoctorId: "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
      };

      const result = await RxChangeAlertsApprovedWithChanges(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        sessionStorage.setItem(
          "patientId",
          location?.state?.rowData?.patientId
        );
        sessionStorage.setItem(
          "rxTabs",
          JSON.stringify([result?.data?.response[0]?.prescriptionForm])
        );
        sessionStorage.setItem(
          "rxHubOptions",
          JSON.stringify(
            result?.data?.response[0]?.prescriptionForm?.rxhubPBMUniqueIdOptions
          )
        );
        sessionStorage.setItem(
          "rxhubPBMUniqueId",
          result?.data?.response[0]?.prescriptionForm?.rxhubPBMUniqueId
        );
        dispatch(loadingPharmacyDropDown());
        sessionStorage.setItem(
          "rxTabsErrors",
          JSON.stringify(result?.data?.response[0]?.prescriptionErrors)
        );
        navigate("/newrxpad");
      } else {
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      setStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Something went wrong!",
          variant: "error",
          open: true,
        };
      });
    } finally {
      setActionType("");
    }
  };
  return (
    <>
      <ContentStyle>
        <Typography
          className="help"
          component="h6"
          color="primary"
          variant="h6"
        >
          Pending Rx Change Alert
          <HelpGuideTooltip
            content={
              <>
                {" "}
                <Typography component="div" variant="body1">
                  Change Prescription related alerts resulting from data
                  discrepancies
                </Typography>
              </>
            }
          />
        </Typography>
        {loader ? (
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            height={"100vh"}
          >
            <CircularProgress color="primary" />
          </Grid>
        ) : (
          <>
            <PatientPharmacyInfoCard
              PatientInfo={patientInformation}
              PharmacyInfo={rxChangeAlertsRequestData?.pharmacyInformation}
            ></PatientPharmacyInfoCard>
            <MedPrescribeRequested
              prescribedData={rxChangeAlertsRequestData?.medicationPrescribed}
              requestedData={medRequestSelectedData}
              handleShowMedRequestPopupClick={handleShowMedRequestPopupClick}
              rxChangeAlertsRequestData={rxChangeAlertsRequestData}
            ></MedPrescribeRequested>
            <MedPrescribedForm
              denialResons={rxChangeAlertsRequestData?.reasonsOptions}
              handleSubmit={handleSubmit}
              actionType={actionType}
              setActionType={setActionType}
              rxChangeAlertsRequestData={rxChangeAlertsRequestData}
              medRequestSelectedData={medRequestSelectedData}
            />
          </>
        )}
      </ContentStyle>
      <YSSnackBar
        message={stateData.message}
        variant={stateData.variant}
        open={stateData.open}
        handleClose={() => {
          setStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
      <DialogPopup
        title="Prescribed matching medication"
        windowsize={"sm"}
        show={DrugNotMatchPopup}
        handleShowPopupClick={handleShowDrugNotMatchPopupClick}
        handleHidePopupClick={handleHideDrugNotMatchPopupClick}
      >
        <DrugNotMatchPopUp
          matchingDrugList={rxChangeAlertsRequestData?.matchingDrugList}
        />
      </DialogPopup>
      <DialogPopup
        title="Patient Selection"
        windowsize={"md"}
        show={PatientNotMatchPopup}
        handleShowPopupClick={handleShowPatientNotMatchPopupClick}
        handleHidePopupClick={handleHidePatientNotMatchPopupClick}
      >
        <PatientNotMatchPopUp
          RequestData={rxChangeAlertsRequestData}
          setMatchingList={setMatchingList}
          setPatientInformation={setPatientInformation}
          handleHidePatientNotMatchPopupClick={
            handleHidePatientNotMatchPopupClick
          }
        />
      </DialogPopup>
      <DialogPopup
        title="Prescribed Status"
        windowsize={"sm"}
        show={ApprovedPopup}
        handleShowPopupClick={handleShowApprovedPopupClick}
        handleHidePopupClick={handleHideApprovedPopupClick}
      >
        <PrescribedStatusPopup sendToPharmacyData={sendToPharmacyData} />
      </DialogPopup>

      <DialogPopup
        title="Medication Requested"
        windowsize={"sm"}
        show={MedRequestPopup}
        handleShowPopupClick={handleShowMedRequestPopupClick}
        handleHidePopupClick={handleHideMedRequestPopupClick}
      >
        <Typography
          variant="h1"
          fontSize={20}
          sx={{
            color: `${DRxTheme.palette.primary.main}`,
          }}
          marginBottom={2}
        >
          Medication Requested List(
          {rxChangeAlertsRequestData?.medicationRequested?.length})
        </Typography>
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          {rxChangeAlertsRequestData?.medicationRequested?.map((row: any) => {
            return (
              <>
                <MedicationRequestedList
                  row={row}
                  getValuesOfDropDown={getValuesOfDropDown}
                  handleHideMedRequestPopupClick={
                    handleHideMedRequestPopupClick
                  }
                  medRequestSelectedData={medRequestSelectedData}
                  setMedRequestSelectedData={setMedRequestSelectedData}
                />
              </>
            );
          })}
        </div>
      </DialogPopup>
    </>
  );
}
